import React, { useEffect, useState } from "react";
import CheckList from "../component/CheckList";
import {
  deleteCheckListService,
  getCheckListQuestionsService,
  getCheckListResponseService,
  getCheckListService,
} from "../services/CheckListService";
import { Apinames } from "../utils/Apiname";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../utils/Common";
import SubmittingChecklist from "../component/SubmittingChecklist";
import AiPreAnalysis from "../component/aces/AiPreAnalysis";
import { getAiSettings, latestAnalyses } from "../services/AiService";
import { AnalysisListItem } from "../types/ai";
import { hasAnyPermission, hasPermission } from "../utils/permissions";


const SubmittedChecklistScreen = () => {
  const navigate = useNavigate();
   const { state } = useLocation();
  const [allList, setAllList] = useState<any[]>([]);
  const [dropDownList, setDropDownList] = useState<any[]>([]);

  const [questionList, setQuestionList] = useState<any[]>([]);
  const [responsesList, setResponsesList] = useState<any[]>([]);
  const [selectedChecklistId, setSelectedChecklistId] = useState<number | null>(
    null
  );
  const [role, setRole] = useState<string | null>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [dropdownLoading, setDropdownLoading] = useState<boolean>(false);


  const [error, setError] = useState<string | null>(null);

  const [show, setShow] = useState(false);
  const [usershow, setUserShow] = useState(false);
  const [preAnalysisId, setPreAnalysisId] = useState<number | null>(null);
  const [latestByChecklist, setLatestByChecklist] = useState<Record<string, AnalysisListItem>>({});
  const [templates, setTemplates] = useState<{ id: number; title: string }[]>([]);
  const [aiEnabled, setAiEnabled] = useState(true);
  const canAnalyse = hasPermission("AI_ANALYSE");
  const seesAi = hasAnyPermission("AI_ANALYSE", "AI_REVIEW");

  useEffect(() => {
    const cookie: any = getCookie("data");
    setRole(cookie.role || null);
  }, []);

  useEffect(() => {
    getCheckList();
    getCheckListService(`${Apinames.checklistAll}?isTemplate=true`)
      .then((r: any) => setTemplates(r?.result || []))
      .catch(() => setTemplates([]));
    if (seesAi) getAiSettings().then((s) => setAiEnabled(s.aiEnabled)).catch(() => setAiEnabled(true));
  }, [seesAi]);

  const getCheckList = async () => {
    try {
      setError(null);
      let endpoint = `${Apinames.checklistAll}?submitted=true`;
      const response = await getCheckListService(endpoint);
      if (response?.result) {
        setAllList(response?.result);
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };

  const deleteCheckList = async (checklistId: number) => {
    try {
      setError(null);
      let endpoint = `${Apinames.checklistDelete}?checklistId=${checklistId}`;
      const response = await deleteCheckListService(endpoint, {});
      if (response?.result) {
        getCheckList();
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };
  const getQuestionList = async (checklistId: number) => {
    if (selectedChecklistId === checklistId && questionList.length > 0) {
      onPressDetailModal();
      return;
    }

    try {
      setError(null);
      setSelectedChecklistId(checklistId);
      setLoading(true);
      let endpoint = `${Apinames.checklistQuestions}?checklistId=${checklistId}`;
      const response = await getCheckListQuestionsService(endpoint);
      if (response?.result) {
        console.log("response", response);
        setQuestionList(response?.result);
        onPressDetailModal();
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const getResponsesList = async (checklistId: number) => {
    if (selectedChecklistId === checklistId && responsesList.length > 0) {
      onPressUserModal();
      return;
    }
    try {
      setError(null);
      setSelectedChecklistId(checklistId);
      setLoading(true);
      let endpoint = `${Apinames.checklistResponses}?checklistId=${checklistId}`;
      const response = await getCheckListResponseService(endpoint);
      if (response?.result) {
        setResponsesList(response?.result);
        onPressUserModal();
      }
    } catch (error) {
      setError("Failed to load List. Please try again later.");
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const onPressDetailModal = () => {
    console.log("onPressDetailModal called");
    setShow(!show);
  };
  const onPressUserModal = () => {
    setUserShow(!usershow);
  };

  useEffect(() => {
    if (!seesAi || allList.length === 0) return;
    latestAnalyses(allList.map((c: any) => c.id))
      .then(setLatestByChecklist)
      .catch(() => setLatestByChecklist({}));
  }, [allList, seesAi, preAnalysisId]);

  return (
    <>
    <AiPreAnalysis checklistId={preAnalysisId} onClose={() => setPreAnalysisId(null)} />
    <SubmittingChecklist
      show={show}
      onPressDetailModal={onPressDetailModal}
      onPressUserModal={onPressUserModal}
      usershow={usershow}
      allList={allList}
      questionList={questionList}
      responsesList={responsesList}
      getResponsesList={getResponsesList}
      getQuestionList={getQuestionList}
      loading={loading}
      mainLoading={mainLoading}
      deleteCheckList={deleteCheckList}
      role={role}
      dropDownList={dropDownList}
      dropdownLoading={dropdownLoading}
      canAnalyse={canAnalyse}
      seesAi={seesAi}
      aiEnabled={aiEnabled}
      templates={templates}
      onAnalyse={(checklistId: number) => setPreAnalysisId(checklistId)}
      latestByChecklist={latestByChecklist}
    />
    </>
  );
};

export default SubmittedChecklistScreen;
